import { PluginEquifaxInDepthTradingHistoryRequest } from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runEquifaxInDepthTradingHistoryRequest = (
  constructPost: ConstructPost,
  data: PluginEquifaxInDepthTradingHistoryRequest,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructPost<NonPaginatedResponse<null>>(
    `${PLUGIN_BASE_PATH}/equifax-in-depth-trading-history-request`,
    { data },
    { preventDefaultErrorToast: true },
  );
